export default {
  // Common
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    filter: 'Фильтр',
    reset: 'Сбросить',
    close: 'Закрыть',
    back: 'Назад',
    next: 'Далее',
    previous: 'Назад',
    loading: 'Загрузка...',
    noData: 'Нет данных',
    actions: 'Действия',
    confirm: 'Подтвердить',
    yes: 'Да',
    no: 'Нет',
  },

  // App
  app: {
    title: 'Crypto CRM',
  },

  // Navigation
  nav: {
    main: 'Основное',
    catalogs: 'Справочники',
    administration: 'Администрирование',
    dashboard: 'Панель управления',
    wallets: 'Кошельки',
    transactions: 'Транзакции',
    rates: 'Курсы монет',
    coins: 'Монеты',
    exchanges: 'Биржи / Офисы',
    expenses: 'Расходы',
    expenseTypes: 'Типы расходов',
    investors: 'Инвесторы',
    clients: 'Клиенты',
    settlements: 'Взаиморасчеты',
    offices: 'Офисы',
    courierTransfers: 'Переводы курьерами',
    financialReports: 'Финансовые отчеты',
    settings: 'Настройки',
    users: 'Пользователи',
    roles: 'Роли',
    permissions: 'Разрешения',
    versioningConfigs: 'Логирование',
    versions: 'История изменений',
    budgetLines: 'Статьи бюджета',
    budgetReport: 'Отчёт по бюджету',
    pnlReport: 'Отчёт о прибылях и убытках',
    walletOperations: 'Операции по кошелькам',
    logout: 'Выйти',
    login: 'Войти',
  },

  // Settings
  settings: {
    title: 'Настройки',
    main: 'Основные',
    icons: 'Иконки',
    theme: 'Тема',
    light: 'Светлая',
    dark: 'Темная',
    weekStart: 'Начало недели',
    sunday: 'Воскресенье',
    monday: 'Понедельник',
    timezone: 'Часовой пояс',
    language: 'Язык',
    english: 'Английский',
    russian: 'Русский',
    navbarIcons: 'Иконки верхней панели',
    savedSuccessfully: 'Настройки успешно сохранены',
    saveError: 'Не удалось сохранить настройки. Попробуйте еще раз.',
    switchToLight: 'Переключить на светлую тему',
    switchToDark: 'Переключить на темную тему',
    showExchangesAndOfficesTogether: 'Показывать биржи и офисы вместе',
    coinFilterInfluencesAllCards: 'Выбор монеты влияет на все карточки',
  },

  // Transactions
  transactions: {
    title: 'Транзакции',
    add: 'Добавить транзакцию',
    edit: 'Редактировать транзакцию',
    date: 'Дата и время транзакции',
    client: 'Клиент',
    searchClient: 'Поиск клиента по телефону',
    searchClientPlaceholder: 'Введите номер телефона для поиска...',
    noClientFound: 'Клиент с таким номером телефона не найден.',
    saveAsNewClient: 'Сохранить как нового клиента',
    typeAtLeast10Digits: 'Введите не менее 10 цифр для создания нового клиента',
    internal: 'Внутренние',
    sold: 'Продано',
    received: 'Получено',
    amount: 'Сумма',
    rate: 'Курс',
    fee: 'Комиссия',
    ourRate: 'Наш курс',
    receiveOurRate: 'Наш курс получения',
    profit: 'Ожидаемая прибыль',
    walletBalance: 'Баланс кошелька',
    operator: 'Оператор (Пользователь)',
    from: 'От',
    to: 'К',
    coin: 'Монета',
    wallet: 'Кошелек',
    fromWallet: 'Из кошелька',
    toWallet: 'В кошелек',
    soldCoin: 'Проданная монета',
    receivedCoin: 'Полученная монета',
    soldAmount: 'Проданная сумма',
    receivedAmount: 'Полученная сумма',
    soldRate: 'Курс продажи',
    receivedRate: 'Курс получения',
    sendFee: 'Комиссия отправки',
    inUsdt: 'в USDT',
    usdt: 'USDT',
    update: 'Обновить',
    // List view
    filters: 'Фильтры',
    coinFilter: 'Монета',
    walletFilter: 'Кошелек',
    walletSearchPlaceholder: 'Введите для поиска...',
    noWalletsFound: 'Кошельки не найдены',
    clientFilter: 'Клиент',
    manager: 'Менеджер',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    all: 'Все',
    clients: 'Клиенты',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    dateColumn: 'Дата',
    fromWalletColumn: 'Из кошелька',
    toWalletColumn: 'В кошелек',
    amountColumn: 'Сумма',
    rateFee: 'Курс / Комиссия',
    rateOurRate: 'Курс / Наш курс',
    clientOperator: 'Клиент/Оператор',
    profitColumn: 'Прибыль',
    actions: 'Действия',
    totalProfit: 'Общая прибыль:',
    areYouSure: 'Вы уверены?',
    // Errors
    enterAtLeast10Digits: 'Пожалуйста, введите не менее 10 цифр для номера телефона',
    enterValidPhone: 'Пожалуйста, введите действительный номер телефона с не менее чем 10 цифрами',
    selectClientOrPhone: 'Пожалуйста, выберите клиента или введите номер телефона с 10+ цифрами',
    failedToCreateClient: 'Не удалось создать клиента: {errors}',
    errorCreatingClient: 'Ошибка создания клиента',
    errorSaving: 'Ошибка сохранения транзакции',
    errorMessage: 'Ошибка: {errors}',
  },

  // Expenses
  expenses: {
    title: 'Расходы',
    add: 'Добавить расход',
    edit: 'Редактировать расход',
    addType: 'Добавить тип расхода',
    date: 'Дата',
    type: 'Тип',
    amount: 'Сумма',
    amountUsdt: 'Сумма (USDT)',
    description: 'Описание',
    wallet: 'Кошелек',
    filters: 'Фильтры',
    walletSearchPlaceholder: 'Введите для поиска...',
    noWalletsFound: 'Кошельки не найдены',
    expenseType: 'Тип расхода',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    list: 'Список расходов',
    dateColumn: 'Дата',
    walletColumn: 'Кошелек',
    typeColumn: 'Тип',
    amountColumn: 'Сумма',
    amountUsdtColumn: 'Сумма USDT',
    userColumn: 'Пользователь',
    descriptionColumn: 'Описание',
    actionsColumn: 'Действия',
    noExpensesFound: 'Расходы не найдены',
    total: 'Итого:',
    addExpenseType: 'Добавить тип расхода',
    name: 'Название',
    namePlaceholder: 'например, Маркетинг',
    nameRequired: 'Название обязательно',
    transactionDate: 'Дата транзакции',
    usdt: 'USDT',
    user: 'Пользователь',
    update: 'Обновить',
    areYouSureDelete: 'Вы уверены, что хотите удалить этот расход?',
    fillAllFields: 'Пожалуйста, заполните все обязательные поля',
    failedToSave: 'Не удалось сохранить расход: {errors}',
    errorSaving: 'Ошибка сохранения расхода',
    errorDeleting: 'Ошибка удаления расхода',
    failedToSaveType: 'Не удалось сохранить тип расхода: {errors}',
    errorSavingType: 'Ошибка сохранения типа расхода',
    fillInName: 'Пожалуйста, введите название',
  },

  // Financial Reports
  financialReports: {
    title: 'Финансовые отчеты',
    create: 'Создать отчет',
    edit: 'Редактировать отчет',
    generateMonthly: 'Сгенерировать месячный',
    generateWeekly: 'Сгенерировать недельный',
    list: 'Список отчетов',
    filters: 'Фильтры',
    reportType: 'Тип отчета',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    periodStart: 'Начало периода',
    periodEnd: 'Конец периода',
    periodDays: 'Дней в периоде',
    days: 'дней',
    description: 'Описание',
    generatedAt: 'Сгенерирован',
    view: 'Просмотр',
    regenerate: 'Пересоздать',
    reportDetails: 'Детали отчета',
    reportData: 'Данные отчета',
    noData: 'Нет данных',
    confirmRegenerate: 'Вы уверены, что хотите пересоздать этот отчет?',
    confirmDelete: 'Вы уверены, что хотите удалить этот отчет?',
    generateAfterCreate: 'Сгенерировать после создания',
    monthlyFactual: 'Факт месячный',
    weeklyFactual: 'Факт недельный',
    monthlyForecast: 'Прогноз месячный',
    combined: 'Факт+Прогноз',
    pnl: 'P&L',
    period: 'Период',
    transactions: 'Транзакции',
    incoming: 'Входящие',
    outgoing: 'Исходящие',
    fees: 'Комиссии',
    expenses: 'Расходы',
    settlements: 'Взаиморасчеты',
    totalExpenses: 'Всего расходов',
    toWallet: 'В кошелек',
    toInvestor: 'Инвестору',
    netIncome: 'Чистый доход',
    totalSettlements: 'Всего взаиморасчетов',
    netChange: 'Чистое изменение',
    walletBalances: 'Балансы кошельков',
    coin: 'Монета',
    balance: 'Баланс',
    balanceUsdt: 'Баланс (USDT)',
    noWallets: 'Кошельки не найдены',
    summary: 'Итого',
    forecastTransactions: 'Прогноз транзакций',
    forecastExpenses: 'Прогноз расходов',
    forecastSettlements: 'Прогноз взаиморасчетов',
    forecastSummary: 'Прогноз итого',
    historicalData: 'Исторические данные',
    monthsAnalyzed: 'Месяцев проанализировано',
    averageIncoming: 'Средние входящие',
    averageOutgoing: 'Средние исходящие',
    averageExpenses: 'Средние расходы',
    factual: 'Факт',
    forecast: 'Прогноз',
    comparison: 'Сравнение',
    variance: 'Отклонение',
    transactionsVariance: 'Отклонение транзакций',
    expensesVariance: 'Отклонение расходов',
    absolute: 'Абсолютное',
    percentage: 'Процентное',
    periodDetails: 'Период и примечание',
    overviewTab: 'Обзор',
    walletsTab: 'Таблица кошельков',
    profitSection: 'Прибыль',
    lossSection: 'Убыток',
    expensesSection: 'Расходы',
    exchangeDifferences: 'Курсовые разницы',
    staking: 'Стейкинг',
    commissions: 'Комиссии',
    totalProfit: 'Итого прибыль',
    pnlResult: 'Результат P&L',
    netPL: 'Чистый P&L',
  },

  // Login
  login: {
    title: 'Вход',
    email: 'Email',
    password: 'Пароль',
    loginButton: 'Войти',
    loginFailed: 'Ошибка входа',
    loginError: 'Ошибка входа',
  },

  // Dashboard
  dashboard: {
    title: 'Панель управления',
    filterByCoin: 'Монета',
    filterByCoinAll: 'Все',
    filterByExchange: 'Биржа',
    totalWallets: 'Всего кошельков',
    totalTransactions: 'Всего транзакций',
    totalBalance: 'Общий баланс',
    usdtByExchange: 'USDT по биржам',
    usdtByOffices: 'USDT по офисам',
    usdtByCoin: 'USDT по монетам',
    exchangesOnly: 'биржи',
    officesOnly: 'офисы',
    totalUsdt: 'Всего USDT',
    totalTodayProfit: 'Прибыль за сегодня',
    todayTotalExpenses: 'Расходы за сегодня',
    usdt: 'USDT',
    unknown: 'Неизвестно',
  },

  // Coins
  coins: {
    title: 'Монеты',
    filter: 'Фильтр монет',
    add: 'Добавить монету',
    edit: 'Редактировать монету',
    list: 'Список монет',
    id: 'ID',
    symbol: 'Символ',
    name: 'Название',
    fiat: 'Фиат',
    fiatYes: 'Да',
    fiatNo: 'Нет',
    symbolPlaceholder: 'например, BTC',
    namePlaceholder: 'например, Bitcoin',
    symbolRequired: 'Символ обязателен',
    nameRequired: 'Название обязательно',
    fillAllFields: 'Пожалуйста, заполните все поля',
    failedToSave: 'Не удалось сохранить монету: {errors}',
    errorSaving: 'Ошибка сохранения монеты: {errors}',
  },

  // Exchanges
  exchanges: {
    title: 'Биржи / Офисы',
    filter: 'Фильтр бирж',
    add: 'Добавить биржу',
    edit: 'Редактировать биржу',
    list: 'Список бирж',
    id: 'ID',
    name: 'Название',
    namePlaceholder: 'например, Binance',
    nameRequired: 'Название обязательно',
    fillName: 'Пожалуйста, введите название',
    office: 'Офис',
    isPhysicalOffice: 'Физический офис',
    physicalOffice: 'Физический офис',
    address: 'Адрес',
    addressPlaceholder: 'Введите адрес',
    failedToSave: 'Не удалось сохранить биржу: {errors}',
    errorSaving: 'Ошибка сохранения биржи: {errors}',
  },

  // Offices
  offices: {
    title: 'Офисы',
    add: 'Добавить офис',
    edit: 'Редактировать офис',
    list: 'Список офисов',
    id: 'ID',
    name: 'Название',
    address: 'Адрес',
    phone: 'Телефон',
    description: 'Описание',
    namePlaceholder: 'например, Главный офис',
    addressPlaceholder: 'Адрес офиса',
    phonePlaceholder: 'Телефон офиса',
    descriptionPlaceholder: 'Дополнительная информация',
    nameRequired: 'Название обязательно',
    fillName: 'Пожалуйста, введите название',
    failedToSave: 'Не удалось сохранить офис: {errors}',
    errorSaving: 'Ошибка сохранения офиса: {errors}',
    areYouSure: 'Вы уверены, что хотите удалить этот офис?',
    failedToDelete: 'Не удалось удалить офис',
    errorDeleting: 'Ошибка удаления офиса',
  },

  // Office Wallets
  officeWallets: {
    title: 'Кошельки офисов',
    add: 'Добавить кошелек офиса',
    edit: 'Редактировать кошелек офиса',
    list: 'Список кошельков офисов',
    filters: 'Фильтры',
    office: 'Офис',
    coin: 'Монета',
    balance: 'Баланс',
    usdtRate: 'Курс USDT',
    usdtValue: 'Стоимость в USDT',
    name: 'Название',
    description: 'Описание',
    grandTotals: 'Итого',
    totalWallets: 'Всего кошельков',
    coinSearchPlaceholder: 'Поиск фиатных монет...',
    noCoinsFound: 'Фиатные монеты не найдены',
    failedToSave: 'Не удалось сохранить кошелек офиса: {errors}',
    errorSaving: 'Ошибка сохранения кошелька офиса',
    areYouSure: 'Вы уверены, что хотите удалить этот кошелек офиса?',
  },

  // Courier Transfers
  courierTransfers: {
    title: 'Переводы курьерами',
    add: 'Добавить перевод',
    edit: 'Редактировать перевод',
    list: 'Список переводов',
    filters: 'Фильтры',
    courier: 'Курьер',
    coin: 'Монета',
    amount: 'Сумма',
    status: 'Статус',
    source: 'Источник',
    destination: 'Назначение',
    transactionDate: 'Дата транзакции',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    description: 'Описание',
    fromWallet: 'Из кошелька',
    fromClient: 'От клиента',
    toWallet: 'В кошелек',
    toClient: 'Клиенту',
    selectClient: 'Выберите клиента',
    selectWallet: 'Выберите кошелек',
    statusReceived: 'Получено из кошельков',
    statusInWay: 'В пути',
    statusFinished: 'Завершено',
    failedToSave: 'Не удалось сохранить курьерский перевод: {errors}',
    errorSaving: 'Ошибка сохранения курьерского перевода',
    areYouSure: 'Вы уверены, что хотите удалить этот курьерский перевод?',
  },

  // Clients
  clients: {
    title: 'Клиенты',
    add: 'Добавить клиента',
    edit: 'Редактировать клиента',
    list: 'Список клиентов',
    filter: 'Фильтр по телефону или ID',
    id: 'ID',
    phone: 'Телефон',
    type: 'Тип',
    internal: 'Внутренний',
    regular: 'Клиент',
    noClientsFound: 'Клиенты не найдены',
    phoneRequired: 'Телефон обязателен',
    fillPhone: 'Пожалуйста, введите номер телефона',
    failedToSave: 'Не удалось сохранить клиента: {errors}',
    errorSaving: 'Ошибка сохранения клиента: {errors}',
    failedToDelete: 'Не удалось удалить клиента',
    errorDeleting: 'Ошибка удаления клиента',
    areYouSureDelete: 'Вы уверены, что хотите удалить этого клиента?',
  },

  // Investors
  investors: {
    title: 'Инвесторы',
    add: 'Добавить инвестора',
    edit: 'Редактировать инвестора',
    list: 'Список инвесторов',
    id: 'ID',
    name: 'Имя',
    phone: 'Телефон',
    email: 'Email',
    comment: 'Комментарий',
    noInvestorsFound: 'Инвесторы не найдены',
    nameRequired: 'Имя обязательно',
    fillName: 'Пожалуйста, введите имя',
    failedToSave: 'Не удалось сохранить инвестора: {errors}',
    errorSaving: 'Ошибка сохранения инвестора: {errors}',
    failedToDelete: 'Не удалось удалить инвестора',
    errorDeleting: 'Ошибка удаления инвестора',
    areYouSureDelete: 'Вы уверены, что хотите удалить этого инвестора?',
  },

  // Users
  users: {
    title: 'Пользователи',
    list: 'Список пользователей',
    id: 'ID',
    email: 'Email',
    roles: 'Роли',
    noRoles: 'Нет ролей',
    noUsersFound: 'Пользователи не найдены',
    manageRoles: 'Управление ролями для {email}',
    failedToUpdateRoles: 'Не удалось обновить роли пользователя',
  },

  // Wallets
  wallets: {
    title: 'Кошельки',
    add: 'Добавить кошелек',
    edit: 'Редактировать кошелек',
    name: 'Название',
    exchange: 'Биржа',
    coin: 'Монета',
    balance: 'Баланс',
    displayName: 'Отображаемое имя',
    office: 'Офис',
    filters: 'Фильтры',
    filterBy: 'Фильтр по',
    all: 'Все',
    exchanges: 'Биржи',
    viewDetails: 'Просмотр деталей',
    grandTotals: 'Общие итоги',
    totalWallets: 'Всего кошельков',
    areYouSure: 'Вы уверены?',
    failedToSave: 'Ошибка: {errors}',
    errorSaving: 'Ошибка сохранения кошелька',
    backToWallets: 'Назад к кошелькам',
  },

  // Settlements
  settlements: {
    title: 'Расчеты',
    add: 'Добавить расчет',
    edit: 'Редактировать расчет',
    date: 'Дата',
    investor: 'Инвестор',
    direction: 'Направление',
    toWallet: 'В кошелек',
    toInvestor: 'Инвестору',
    amount: 'Сумма',
    amountUsdt: 'Сумма (USDT)',
    rate: 'Курс',
    description: 'Описание',
    filters: 'Фильтры',
    walletSearchPlaceholder: 'Введите для поиска...',
    noWalletsFound: 'Кошельки не найдены',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    user: 'Пользователь',
    dateColumn: 'Дата',
    investorColumn: 'Инвестор',
    walletColumn: 'Кошелек',
    directionColumn: 'Направление',
    amountColumn: 'Сумма',
    amountUsdtColumn: 'Сумма USDT',
    rateColumn: 'Курс',
    userColumn: 'Пользователь',
    descriptionColumn: 'Описание',
    noSettlementsFound: 'Расчеты не найдены',
    total: 'Итого:',
    fillAllFields: 'Пожалуйста, заполните все обязательные поля',
    setValidRate: 'Пожалуйста, установите действительный курс',
    setValidAmountRate: 'Пожалуйста, установите действительную сумму и курс',
    failedToSave: 'Не удалось сохранить расчет: {errors}',
    errorSaving: 'Ошибка сохранения расчета',
    areYouSureDelete: 'Вы уверены, что хотите удалить этот расчет?',
    failedToDelete: 'Не удалось удалить расчет',
    errorDeleting: 'Ошибка удаления расчета',
  },

  // Rates
  rates: {
    title: 'Курсы монет',
    filteredByCoin: '(Фильтр по монете)',
    filterByCoin: 'Фильтр по монете',
    coins: 'Монеты',
    rates: 'Курсы',
    add: 'Добавить курс',
    edit: 'Редактировать курс',
    getRates: 'Получить курсы (CryptoCompare)',
    coin: 'Монета',
    rateUsdt: 'Курс (USDT)',
    timestamp: 'Временная метка',
    noRatesFound: 'Курсы не найдены',
    fillCoinRate: 'Пожалуйста, заполните монету и курс',
    failedToLoadCoins: 'Не удалось загрузить монеты',
    coinNotFound: 'Выбранная монета не найдена',
    errorsOccurred: 'Произошли некоторые ошибки:\n{errors}',
    failedToFetch: 'Не удалось получить курсы с CryptoCompare',
    areYouSureDelete: 'Вы уверены, что хотите удалить этот курс?',
    failedToSave: 'Не удалось сохранить курс',
    errorFetching: 'Ошибка: {error}',
  },

  // Budget Lines
  budgetLines: {
    title: 'Статьи бюджета',
    add: 'Добавить статью',
    addChild: 'Добавить дочернюю',
    edit: 'Редактировать статью',
    list: 'Список статей бюджета',
    id: 'ID',
    name: 'Название',
    parent: 'Родитель',
    order: 'Порядок',
    isFolder: 'Папка',
    active: 'Активна',
    yes: 'Да',
    no: 'Нет',
    namePlaceholder: 'например, Зарплата',
    nameRequired: 'Название обязательно',
    noBudgetLinesFound: 'Статьи бюджета не найдены',
    fillName: 'Пожалуйста, введите название',
    failedToSave: 'Не удалось сохранить статью бюджета: {errors}',
    errorSaving: 'Ошибка сохранения статьи бюджета: {errors}',
    areYouSureDelete: 'Вы уверены, что хотите удалить эту статью бюджета?',
    failedToDelete: 'Не удалось удалить статью бюджета',
    errorDeleting: 'Ошибка удаления статьи бюджета',
  },

  walletOperations: {
    title: 'Операции по кошелькам',
    filteredByDocument: 'Фильтр: {type} №{id}',
    showAll: 'Показать все',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    walletFilter: 'Кошелёк',
    coinFilter: 'Монета',
    totalPositive: 'Итого (+)',
    totalNegative: 'Итого (−)',
    totalNet: 'Общий итог',
    operatedAt: 'Дата и время',
    documentType: 'Тип документа',
    documentId: 'ID док.',
    wallet: 'Кошелёк',
    amount: 'Сумма',
    amountUsdt: 'Сумма USDT',
    operationKind: 'Вид',
    noOperations: 'Нет операций',
    noOperationsForDocument: 'Нет операций по этому документу',
    docType: {
      Transaction: 'Транзакция',
      Settlement: 'Взаиморасчёт',
      Expense: 'Расход',
      CourierTransfer: 'Перевод курьером',
    },
    kind: {
      principal: 'Основная',
      commission: 'Комиссия',
      incoming: 'Входящая',
      to_wallet: 'В кошелёк',
      to_investor: 'Инвестору',
      expense: 'Расход',
      courier_out: 'Курьером из',
      courier_in: 'Курьером в',
    },
    linkTitle: 'Операции по документу',
  },

  passiveOperations: {
    title: 'Пассивные операции',
    filteredByDocument: 'Фильтр: {type} №{id}',
    showAll: 'Показать все',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    investorFilter: 'Инвестор',
    operatedAt: 'Дата и время',
    investor: 'Инвестор',
    documentType: 'Тип документа',
    documentId: 'ID док.',
    amountUsdt: 'Сумма USDT',
    operationKind: 'Вид',
    totalPositive: 'Итого (+)',
    totalNegative: 'Итого (−)',
    totalNet: 'Общий итог',
    noOperations: 'Нет операций',
    noOperationsForDocument: 'Нет операций по этому документу',
  },

  // Budget Report
  budgetReport: {
    title: 'Отчёт по бюджету',
    onDate: 'На дату',
    onMonth: 'Месяц',
    onYear: 'Год',
    dateFrom: 'С',
    dateTo: 'По',
    periodDay: 'День',
    periodMonth: 'Месяц',
    periodYear: 'Год',
    daysInRange: '{days} дн.',
    weeksInMonth: 'Недели в {month}',
    monthsInYear: 'Месяцы в {year}',
    budgetLine: 'Статья бюджета',
    noData: 'Нет данных. Выберите дату и период.',
  },

  // ExpenseTypes
  expenseTypes: {
    title: 'Типы расходов',
    add: 'Добавить тип расхода',
    edit: 'Редактировать тип расхода',
    list: 'Список типов расходов',
    id: 'ID',
    name: 'Название',
    namePlaceholder: 'например, Маркетинг',
    nameRequired: 'Название обязательно',
    noExpenseTypesFound: 'Типы расходов не найдены',
    fillName: 'Пожалуйста, введите название',
    failedToSave: 'Не удалось сохранить тип расхода: {errors}',
    errorSaving: 'Ошибка сохранения типа расхода: {errors}',
  },

  // Roles
  roles: {
    title: 'Роли',
    add: 'Добавить роль',
    edit: 'Редактировать роль',
    list: 'Список ролей',
    id: 'ID',
    name: 'Название',
    description: 'Описание',
    permissions: 'Разрешения',
    users: 'Пользователи',
    noRolesFound: 'Роли не найдены',
    nameRequired: 'Название обязательно',
    managePermissions: 'Управление разрешениями для {name}',
    failedToSave: 'Не удалось сохранить роль',
    failedToCreate: 'Не удалось создать роль',
    failedToUpdatePermissions: 'Не удалось обновить разрешения',
    areYouSureDelete: 'Вы уверены, что хотите удалить эту роль?',
    failedToDelete: 'Не удалось удалить роль',
  },

  // Permissions
  permissions: {
    title: 'Разрешения',
    add: 'Добавить разрешение',
    edit: 'Редактировать разрешение',
    list: 'Список разрешений',
    id: 'ID',
    name: 'Название',
    controller: 'Контроллер',
    action: 'Действие',
    description: 'Описание',
    roles: 'Роли',
    noRoles: 'Нет ролей',
    noPermissionsFound: 'Разрешения не найдены',
    nameRequired: 'Название обязательно',
    controllerRequired: 'Контроллер обязателен',
    failedToSave: 'Не удалось сохранить разрешение',
    failedToCreate: 'Не удалось создать разрешение',
    areYouSureDelete: 'Вы уверены, что хотите удалить это разрешение?',
    failedToDelete: 'Не удалось удалить разрешение',
  },

  // WalletDetail
  walletDetail: {
    title: 'Детали кошелька',
    edit: 'Редактировать кошелек',
    backToWallets: 'Назад к кошелькам',
    name: 'Название',
    address: 'Адрес',
    exchange: 'Биржа',
    office: 'Офис',
    coin: 'Монета',
    balance: 'Баланс',
    balanceAnalysisPeriod: 'Период анализа баланса:',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    custom: 'Произвольный',
    startingBalance: 'Начальный баланс',
    incomingTransactions: '+ Входящие транзакции',
    outgoingTransactions: '- Исходящие транзакции',
    expenses: '- Расходы',
    settlementsToWallet: '+ Расчеты в кошелек',
    settlementsToInvestor: '- Расчеты инвестору',
    netChange: 'Чистое изменение',
    endingBalance: 'Конечный баланс',
    selectDateRangeBreakdown: 'Выберите диапазон дат для просмотра разбивки баланса',
    selectDateRangeChart: 'Выберите диапазон дат для просмотра графика баланса',
    walletName: 'Название кошелька',
    walletNamePlaceholder: 'Необязательное пользовательское название для этого кошелька',
    addressPlaceholder: 'Адрес кошелька (например, адрес блокчейна)',
    balanceHistory: 'История баланса',
    loadingHistory: 'Загрузка истории баланса...',
    noBalanceChanges: 'Изменения баланса для этого кошелька не найдены.',
    dateColumn: 'Дата',
    typeColumn: 'Тип',
    descriptionColumn: 'Описание',
    balanceBeforeColumn: 'Баланс до',
    balanceChangeColumn: 'Изменение баланса',
    balanceAfterColumn: 'Баланс после',
    sendFeeColumn: 'Комиссия отправки',
    userColumn: 'Пользователь',
    transaction: 'Транзакция',
    expense: 'Расход',
    settlement: 'Расчет',
    editItem: 'Редактировать',
    deleteItem: 'Удалить',
    areYouSureDelete: 'Вы уверены, что хотите удалить этот {type}?',
    failedToDelete: 'Не удалось удалить {type}',
    errorDeleting: 'Ошибка удаления {type}',
    invalidWalletId: 'Недействительный ID кошелька',
    failedToLoad: 'Не удалось загрузить данные кошелька: {status}',
    errorLoading: 'Ошибка загрузки данных кошелька',
    selectClientOrPhone: 'Пожалуйста, выберите клиента или введите номер телефона с 10+ цифрами',
    errorSavingTransaction: 'Ошибка сохранения транзакции',
    fillAllFields: 'Пожалуйста, заполните все обязательные поля',
    failedToSaveExpense: 'Не удалось сохранить расход: {errors}',
    errorSavingExpense: 'Ошибка сохранения расхода',
    failedToSaveSettlement: 'Не удалось сохранить расчет: {errors}',
    errorSavingSettlement: 'Ошибка сохранения расчета',
    enterAtLeast10Digits: 'Пожалуйста, введите не менее 10 цифр для номера телефона',
    failedToCreateClient: 'Не удалось создать клиента: {errors}',
    errorCreatingClient: 'Ошибка создания клиента',
  },

  // VersioningConfigs
  versioningConfigs: {
    title: 'Логи',
    list: 'Управление логированием',
    modelName: 'Название модели',
    description: 'Описание',
    enabled: 'Включено',
    noConfigsFound: 'Конфигурации версионирования не найдены',
    edit: 'Редактировать конфигурацию',
    modelNameRequired: 'Название модели обязательно',
    failedToSave: 'Не удалось сохранить конфигурацию',
    failedToCreate: 'Не удалось создать конфигурацию',
    failedToUpdate: 'Не удалось обновить конфигурацию',
  },

  // Versions
  versions: {
    title: 'История изменений',
    list: 'История изменений',
    filters: 'Фильтры',
    modelType: 'Тип модели',
    itemId: 'ID записи',
    event: 'Событие',
    user: 'Пользователь',
    dateFrom: 'Дата с',
    dateTo: 'Дата по',
    dateFilter: 'Фильтр по дате',
    date: 'Дата',
    model: 'Модель',
    changes: 'Изменения',
    fieldsChanged: 'полей изменено',
    created: 'Создано',
    destroyed: 'Удалено',
    total: 'Всего',
    noVersionsFound: 'Версии не найдены',
    versionDetails: 'Детали версии',
    basicInfo: 'Основная информация',
    item: 'Запись',
    before: 'До',
    after: 'После',
    createdData: 'Созданные данные',
    field: 'Поле',
    value: 'Значение',
    noChanges: 'Нет изменений для отображения',
    viewDetails: 'Просмотр деталей',
    openObject: 'Открыть объект',
    objectDeleted: 'Объект удален',
  },

  // Errors
  errors: {
    unauthorized: 'Не авторизован',
    forbidden: 'Доступ запрещен',
    notFound: 'Не найдено',
    serverError: 'Ошибка сервера',
    networkError: 'Ошибка сети',
    unknownError: 'Неизвестная ошибка',
    ok: 'OK',
  },
}

